const ENDPOINTS = {
  getProductAllimages: '/product-all-images',
  brandsList: '/admin/brands',
  brandOptions: '/admin/brand-options',
  newBrandsList: '/admin/new-brands',
  shortLinkBackupBrandsList: '/admin/short-link-backup-brands',
  addShortLinkBackupBrand: '/admin/short-link-backup-brands/:id/add',
  removeShortLinkBackupBrand: '/admin/short-link-backup-brands/:id/remove',
  reorderShortLinkBackupBrands: '/admin/short-link-backup-brands/reorder',
  setPriorityUpdateForBrand:
    '/admin/short-link-backup-brands/:id/priority-update',
  shortLinkBackupBrandLogs: '/admin/short-link-backup-brands/logs',
  categoryBackupBrandsList: '/admin/category-backup-brands',
  addCategoryBackupBrand: '/admin/category-backup-brands/:id/add',
  removeCategoryBackupBrand: '/admin/category-backup-brands/:id/remove',
  reorderCategoryBackupBrands: '/admin/category-backup-brands/reorder',
  brandXPathByTitle: '/admin/xpathPattern',
  createUpdateXPathPattern: '/admin/xpathPattern',
  removePattern: '/admin/xpathPattern',
  brandsChangelog: '/admin/brands-changelog',
  brandCategories: '/admin/brand-categories',
  brandCategoryUpdate: '/admin/brand-categories/:id',
  brandCategoriesUpdatePositions: '/admin/brand-categories/update-positions',
  subBrandsList: '/admin/brands/subbrands',
  networkTransactions: '/admin/transactions',
  exportNetworkTransactions: '/admin/custom/transactions/export',
  updateNetworkTransactions: '/admin/transactions/:id',
  revenues: '/admin/revenues',
  shortenLink: '/brands/shortLinks',
  getShortLinks: '/admin/short-links',
  parseProduct: '/parse-product-link',
  getJoinPages: '/join-pages',
  updateJoinPages: '/join-pages/update',
  memberStatistics: '/users/memberStatistics',
  members: {
    all: '/admin/users',
    getExtensionData: '/admin/custom/user/:id/extension-info',
    api2All: '/admin/custom/users',
    api2Export: '/admin/custom/users/export',
    downloadExportFile: '/admin/users/download',
    updateMember: '/admin/users/:id',
    changeUserStatus: '/admin/users/:id/status',
    togglePaymentHeld: '/admin/users/:id/togglePaymentHeld',
    changeIsPro: '/admin/users/:id/pro',
    changeIsShownInTheChirpyest: '/admin/users/:id/is-theChirpyest',
    changeIsShortLinkReferralAllowed:
      '/admin/users/:id/is-short-link-referral-allowed',
    changeCanCreateForwardableBoards:
      '/admin/users/:id/can-create-forwardable-shopping-boards',
    changeIsCreator: '/admin/users/:id/is-creator',
    changeIsPowerUser: '/admin/users/:id/is-power-user',
    changeIsNewsletter: '/admin/users/:id/is-newsletter',
    referralBonusStatus: '/admin/users/:id/is-referral-bonus',
    updateProSharePercent: '/admin/users/:id/pro-share-percent',
    updateRoles: '/admin/users/:id/roles',
  },
  brands: {
    brandUsers: '/brand/:id/brand-users',
    toggleBrandShownIn3rdParty: '/admin/brands/:id/toggleShownIn3rdParty',
    toggleBrandShownInExtension: '/admin/brands/:id/toggleShownInExtension',
    toggleSubBrandShownInExtension:
      '/admin/brands/subbrands/:id/toggleShownInExtension',
    toggleBrandShownInChromeExtension:
      '/admin/brands/:id/toggleShownInChromeExtension',
    toggleSubBrandShownInChromeExtension:
      '/admin/brands/subbrands/:id/toggleShownInChromeExtension',
    updateTier: '/admin/brands/:id/updateTier',
    updateCategories: '/admin/brands/:id/updateCategories',
    updateCategoriesSubBrand: '/admin/brands/subbrands/:id/updateCategories',
  },
  exports: {
    createExportLog: '/export-logs',
    getExports: '/export-logs/all',
  },
  payments: {
    all: '/admin/payments',
    readyToPay: '/admin/payments/ready-to-pay',
    sendPayouts: '/admin/send-payments',
    referrals: '/admin/referrals-payments',
    referralsToPay: '/admin/payments/referrals-to-pay',
    pendingReferrals: '/admin/payments/pending-referrals',
    sendReferralsPayments: '/admin/send-referrals-payments',
    paymentHeldLogs: '/admin/payment-held-logs',
  },
  proShareCommissions: {
    all: '/admin/pro-shared-commission',
    readyToPay: '/admin/pro-shared-commission/ready-to-pay',
    sendPayouts: '/admin/pro-shared-commission/sendPayments',
  },
  settings: {
    all: '/settings',
    updateSettings: '/settings/:name',
    customCommissionSplit: '/admin/custom-split-percent',
    adminRole: '/settings/admin-type',
    promptText: '/settings/prompt-text',
  },
  subscription: {
    all: '/subscription',
    brandsList: '/admin/brands-list',
  },
  admins: {
    all: '/admin/admins',
    deleteAdmin: '/admin/admins/:id',
    editAdmin: '/admin/admins/:id',
    search: '/admin/users/search',
  },
  banner: {
    all: '/admin/banner',
    deleteBanner: '/banner/:id',
    editBanner: '/banner/:id',
    addBanner: '/banner',
    updatePosition: '/banner/:id/update-position',
  },
  categories: {
    all: '/admin/categories',
    topProductsByPage: '/top-category-products/:categoryPage',
    topProductsById: '/top-category-products/:id',
    topProducts: '/top-category-products',
    updatePosition: '/top-category-products/update-position',
  },
  catalogues: {
    all: '/admin/catalogues',
    brandsCatalogues: '/admin/brands/catalogues',
    catalogueById: '/admin/catalogues/catalogueId',
    updatePosition: '/admin/catalogues/:id/update-position',
    updatePriority: '/admin/catalogues/:catalogueId/update-priority',
  },
  trending: {
    all: '/trending',
    deleteTrendingProduct: '/trending/:id',
    updatePosition: '/trending/update-position',
  },
  topProducts: {
    all: '/top-products',
    deleteTopProduct: '/top-products/:id',
    updatePosition: '/top-products/update-position',
  },
  parserLogs: 'product-parser-failed-log',
  cms: {
    all: '/cms',
    byName: '/cms/:name',
  },
  editPages: {
    all: '/edit-pages',
    editPage: '/edit-pages/:id',
    products: '/edit-pages/:id/products',
    deleteProduct: '/edit-pages/:id/products/:productId',
    updatePosition: '/edit-pages/:id/products/:productId/update-position',
    pageById: '/edit-pages/:id',
  },
  contentGenerator: {
    all: '/content-pages',
    generate: '/content-pages/generate',
    generateStream: '/content-pages/generate-stream',
    productSearch: '/content-pages/product-search',
    draft: '/content-pages/draft',
    generateKeywords: '/content-pages/generate-keywords',
    single: '/content-pages/:id',
    publicSlug: '/content-pages/public/:slug',
    publish: '/content-pages/:id/publish',
    unpublish: '/content-pages/:id/unpublish',
    schedule: '/content-pages/:id/schedule',
    shareLink: '/content-pages/:id/share-link',
    regenerate: '/content-pages/:id/regenerate',
    regenerateStream: '/content-pages/:id/regenerate-stream',
    addProductsStream: '/content-pages/:id/add-products-stream',
    featureImageFromUrl: '/content-pages/feature-image/from-url',
    featureImageCollage: '/content-pages/feature-image/collage',
    templates: '/content-templates',
    tones: '/writing-tones',
    contentTypes: '/content-types',
    writingTones: '/content-generator/writing-tones',
    writingTone: '/content-generator/writing-tones/:id',
    contentTypesList: '/content-generator/content-types',
    contentType: '/content-generator/content-types/:id',
    bulk: '/content-pages/bulk',
    curaeterLayout: '/content-pages/curaeter-layout',
  },
  editorialCategories: {
    active: '/editorial-categories/active',
    all: '/editorial-categories',
    single: '/editorial-categories/:id',
    updatePositions: '/editorial-categories/update-positions',
  },
  dashboard: {
    getUserProfile: '/admin/user/:id/profile',
    getUserPayments: '/admin/user/:id/payments',
    getUserRecruits: '/admin/user/:id/signed-up-by-you',
  },
  analytics: {
    revenues: {
      getSales: '/analytics/sales',
      getCommission: '/analytics/commission',
      getCashback: '/analytics/cashback',
      getRevenues: '/analytics/revenue',
    },
    members: {
      getTotalMembers: '/analytics/members',
      getMembersTypes: '/analytics/members-types',
      getPaymentsTypes: '/analytics/payment-types',
    },
    membersUsage: {
      getTotalMembersBuyingItems: '/analytics/members-buying-items',
      getTotalActiveShoppingBoards: '/analytics/active-shopping-boards',
      getTotalShareLinksCreated: '/analytics/share-links-created',
      getTotalMembersUsingSite: '/analytics/members-using-site',
    },
  },
  revShare: {
    revShareList: '/admin/revshare',
    report: '/admin/revshare/report',
  },
};

export default ENDPOINTS;
